<script>
import con from '@services/connection'
import Title from '@components/section-title'
import { GlobalBus } from '@services/bus'
import { MODAL, RELOAD } from '@constants/Text'
import { adicionarTransacao } from '@constants/URL'
import { possivelJSON } from '@utils/Format'
import Vue from 'vue'

export default {
  components: { Title },
  data() {
    return {
      busModal: new Vue(),
      loading: false,
      loading_save: false,
      nao_mostrar: false,
      contas: [],
      headers: [
        {
          text: 'Instituição',
          value: 'nome',
        },
        {
          text: 'Conta',
          value: 'conta_corretora',
          sortable: false,
        },
        {
          text: '',
          value: 'actions',
          sortable: false,
          width: 50,
        },
      ],
      contas_selecionadas: [],
      contas_salvas: [],
    }
  },
  computed: {
    hasAccLoading() {
      return this.contas.some((item) => {
        return item.loading
      })
    },
  },
  watch: {
    hasAccLoading(newVal) {
      if (!newVal) {
        // Finalizou todas as atualizações
        this.loading_save = false
        this.$showSnack({
          text: 'Atualizações realizadas.',
          button: true,
        })
        GlobalBus.$emit(RELOAD.ACCOUNT)
        if (this.contas_salvas.length === this.contas.length) {
          setTimeout(() => {
            this.busModal.$emit('dialog', false)
          }, 3000)
        }
      }
    },
  },
  created() {
    GlobalBus.$on(MODAL.CONSENTIR_CRAWLER_DIARIO, this.open)
  },
  beforeDestroy() {
    GlobalBus.$off(MODAL.CONSENTIR_CRAWLER_DIARIO, this.open)
  },
  methods: {
    clear() {
      this.loading = false
      this.loading_save = false
      this.nao_mostrar = false
      this.contas_selecionadas = []
      this.contas_salvas = []
    },
    async open() {
      await this.carregarContas()

      if (this.contas.length) {
        this.busModal.$emit('dialog', true)
      }
    },
    async carregarContas() {
      if (!this.$currentUser().IS_CLIENTE) {
        return
      }

      if (this.loading) {
        return
      }

      this.loading = true

      const r = await con.get(adicionarTransacao.bancos.contas_cliente)

      if (r && r.status === 200) {
        this.contas = possivelJSON(r.value).filter((item) => {
          return item.codigo !== -1 && item._must_sign_agreement
        })
      } else {
        this.contas = []
      }

      this.loading = false

      return true
    },
    save() {
      if (this.loading_save) {
        return
      }
      this.loading_save = true

      const contasSelecionadas = this.contas_selecionadas.map((item) => {
        return item.id_conta
      })

      // Iterar entre as contas
      this.contas.forEach((item) => {
        if (!this.contas_salvas.includes(item.id_conta)) {
          if (contasSelecionadas.includes(item.id_conta)) {
            // Envia as contas selecionadas para o back para aprovar
            this.saveAccount(item, true)
          } else {
            // Para contas nao selecionadas
            if (this.nao_mostrar) {
              // Se marcar para nao mostrar novamente, assinada com negativo elas
              this.saveAccount(item, false)
            }
          }
        }
      })
    },
    async saveAccount(acc, aprovado) {
      // Loading especifico da conta?
      this.$set(acc, 'loading', true)
      // Enviar para rota de edição
      const data = {
        id_conta: acc.id_conta,
        consentimento_aprovado: aprovado,
        consentimento_assinado: true,
      }
      const r = await con.post(adicionarTransacao.bancos.edit, data)
      // const r = await con.post('/mirror', data)

      this.$set(acc, 'loading', false)
      this.$set(acc, 'response', r)

      if (r && r.status === 200) {
        // Se obteve sucesso, salva numa lista separada
        this.contas_salvas.push(acc.id_conta)
      }
    },
  },
}
</script>

<template>
  <BaseModal :bus="busModal" maxWidth="900px">
    <Title title="Atualização diária" />
    <div>
      <div>
        <p>
          Para melhorar a sua experiência, nós podemos atualizar automaticamente
          as suas contas de investimentos, diariamente, para você e seu
          profissional terem sempre acesso aos dados mais atuais.
        </p>
        <p>
          Conforme regulação, esse consentimento é fornecido pelo prazo de 12
          meses. Após esse prazo, você pode renovar a permissão.
        </p>
        <p> Selecione as contas que deseja atualizar diariamente: </p>
      </div>
      <v-data-table
        v-model="contas_selecionadas"
        :headers="headers"
        :items="contas"
        :loading="loading"
        height="250"
        fixed-header
        show-select
        disable-pagination
        hide-default-footer
        item-key="id_conta"
      >
        <template v-slot:header.data-table-select="props">
          <v-simple-checkbox
            v-model="props.props.value"
            :indeterminate="props.props.indeterminate"
            color="primary"
            :disabled="loading_save"
            v-on="props.on"
          />
        </template>
        <template v-slot:item.data-table-select="props">
          <v-simple-checkbox
            :value="props.isSelected"
            color="primary"
            :disabled="
              loading_save || contas_salvas.includes(props.item.id_conta)
            "
            @input="props.select($event)"
          />
        </template>
        <template v-slot:item.conta_corretora="{ item }">
          <div>
            {{
              item.cpf ||
                item.conta ||
                item.conta_corretora ||
                item.email ||
                '-'
            }}
          </div>
        </template>
        <template v-slot:item.actions="{ item }">
          <div>
            <v-progress-circular
              v-if="item.loading"
              indeterminate
              size="18"
              color="primary"
            />
            <div v-if="item.response">
              <v-tooltip v-if="item.response.status === 200" left>
                <template v-slot:activator="{ on }">
                  <v-icon small color="success" v-on="on">
                    mdi-check-outline
                  </v-icon>
                </template>
                <span>
                  {{ item.response.message }}
                </span>
              </v-tooltip>
              <v-tooltip v-if="item.response.status !== 200" left>
                <template v-slot:activator="{ on }">
                  <v-icon small color="red" v-on="on">
                    mdi-alert-circle-outline
                  </v-icon>
                </template>
                <span>
                  {{ item.response.message }}
                </span>
              </v-tooltip>
            </div>
          </div>
        </template>
      </v-data-table>

      <v-checkbox
        v-model="nao_mostrar"
        label="Não mostrar novamente este aviso."
        :disabled="loading_save"
      />
    </div>

    <template v-slot:actions="{ close }">
      <v-spacer />
      <BaseButton underlined @click="close">
        Cancelar
      </BaseButton>
      <BaseButton primary :loading="loading_save" @click="save">
        Salvar
      </BaseButton>
      <v-spacer />
    </template>
  </BaseModal>
</template>


